import { Box, Card, CardHeader } from '@mui/material';

const WidgetWrapper = ({
    children,
    sx = {},
    title = '',
    subheader = '',
    ...other
}) => (
    <Card
        sx={{
            width: '100%',
            height: '100%',
            boxShadow: 0,
            border: (theme) => `solid 1px ${theme.palette.divider}`,
            borderRadius: '20px',
            bgcolor: (theme) => theme.palette.background.paper,
            ...sx
        }}
        {...other}
    >
        <Box
            sx={{
                bgcolor: '#fff',
                padding: 2.5,
                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
            }}
        >
            <CardHeader
                title={title}
                titleTypographyProps={{ variant: 'body1' }}
                sx={{ p: 0 }}
                // action={
                //     <IconButton aria-label="settings">
                //         <MinusSquareCustom1LinearIcon />
                //     </IconButton>
                // }
            />
        </Box>
        {children}
    </Card>
);
export default WidgetWrapper;
